import * as session from "../session/types";
import { LOADING_STATES } from "./constants";

import {
    FETCH_USER_INVITATION_TOKEN_FAILURE,
    FETCH_USER_INVITATION_TOKEN_REQUEST,
    FETCH_USER_INVITATION_TOKEN_SUCCESS,
    RESET_PASSWORD_WITH_TOKEN_FAILURE,
    RESET_PASSWORD_WITH_TOKEN_REQUEST,
    RESET_PASSWORD_WITH_TOKEN_SUCCESS
} from "./actions";

const INITIAL_STATE = {
    tokens: {},
    isResettingPassword: false
};

function mergeStatusForToken(state, tokenId, tokenStatus, error) {
    return {
        ...state,
        tokens: {
            ...state.tokens,
            [tokenId]: {
                status: tokenStatus,
                error
            }
        }
    };
}

export default function user(state = INITIAL_STATE, action) {
    switch (action.type) {
        case session.RESET_AUTH:
            return INITIAL_STATE;

        case FETCH_USER_INVITATION_TOKEN_REQUEST:
            return mergeStatusForToken(
                state,
                action.tokenId,
                LOADING_STATES.loading
            );

        case FETCH_USER_INVITATION_TOKEN_SUCCESS:
            return mergeStatusForToken(
                state,
                action.tokenId,
                LOADING_STATES.loaded
            );

        case FETCH_USER_INVITATION_TOKEN_FAILURE:
            return mergeStatusForToken(
                state,
                action.tokenId,
                LOADING_STATES.error,
                action.error
            );

        case RESET_PASSWORD_WITH_TOKEN_REQUEST:
            return {
                ...state,
                isResettingPassword: true
            };

        case RESET_PASSWORD_WITH_TOKEN_SUCCESS:
            return {
                ...state,
                isResettingPassword: false
            };

        case RESET_PASSWORD_WITH_TOKEN_FAILURE:
            return {
                ...state,
                isResettingPassword: false
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/user/reducers.js